<app-crud-table
  heading="Personas"
  itemTypeName="Persona"
  [items]="items"
  [columns]="columns"
  [loading]="loading"
  (toggle)="toggle($event)"
  (delete)="delete($event)"
  (showItemDialog)="onShowItemDialog($event)"
></app-crud-table>

<p-dialog [(visible)]="showItemDialog" [header]="getDialogHeader()" [style]="{ width: '65%' }" [modal]="true" (onHide)="onPersonaDialogCancel()">
  <app-persona-dialog         *ngIf="showItemDialog"
                              [editedItem]="clonedItem"
                              [processing]="processing$ | async"
                              (onAddPersona)="handleAddPersona($event)"
                              (onEditPersona)="handleEditPersona($event)"
                              (onCancel)="onPersonaDialogCancel()"></app-persona-dialog>
</p-dialog>

<ng-template #reasoningEffortTemplate let-item="item">
  <span>{{ getReasoningEffortLabel(item.reasoningEffortLevel) }}</span>
</ng-template>
